import {
	findClosestElementByClass
} from "./closest";
import lozad from 'lozad/dist/lozad.js';

export const elements = {
	IncomingInstanceOfComponent: null,
	counter: function ($root, parentClassName, customToShow, IncomingInstanceOfComponent) {
		this.IncomingInstanceOfComponent = IncomingInstanceOfComponent;
		if ($root) {
			const parentElements = $root.querySelectorAll(`.${parentClassName}`);
			parentElements.forEach(parent => {
				const childrenElementsArray = Array.from(parent.querySelectorAll('[data-channel]'));
				const options = {
					amount: parent.childElementCount,
					arr: childrenElementsArray,
					parent: parent
				};
				let width = window.innerWidth;
				let changeWidth = false;
				this.resizeAction(options, customToShow, true);
				window.addEventListener('resize', () => {
					if ((width < 768 && window.innerWidth >= 768) || (width >= 768 && window.innerWidth < 768)) {
						changeWidth = true;
					}
					this.resizeAction(options, customToShow, changeWidth);
					width = window.innerWidth;
				});
			});
		}
	},
	resizeAction: function (options, customToShow, changeWidth) {
		if (customToShow === 'popup') {
			if (window.innerWidth < 768 && options.amount > 9 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 8;
				this.actionByAmount(newObj);
				return;
			}
			if (window.innerWidth >= 768 && window.innerWidth < 1200 && options.amount > 33 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 32;
				this.actionByAmount(newObj);
				return;
			}
			if (window.innerWidth >= 1200 && options.amount > 39 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 38;
				this.actionByAmount(newObj);
				return;
			} else return;
		}

		if (customToShow === 'popup_simulator') {
			if (window.innerWidth < 768 && options.amount > 12 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 11;
				this.actionByAmount(newObj);
				return;
			}
			if (window.innerWidth >= 768 && window.innerWidth < 1200 && options.amount > 15 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 14;
				this.actionByAmount(newObj);
				return;
			}
			if (window.innerWidth >= 1200 && options.amount > 27 && changeWidth) {
				const newObj = Object.create(options);
				newObj.elementsToShow = 26;
				this.actionByAmount(newObj);
				return;
			} else return;
		}

		if (window.innerWidth < 768 && customToShow && options.amount > 4 && changeWidth) {
			const newObj = Object.create(options);
			newObj.elementsToShow = 3;
			this.actionByAmount(newObj);
			return;
		}

		if (customToShow && options.amount > 5 && changeWidth) {
			const newObj = Object.create(options);
			newObj.elementsToShow = 4;
			this.actionByAmount(newObj);
			return;
		}
		if (window.innerWidth < 768 && options.amount > 12 && changeWidth) {
			const newObj = Object.create(options);
			newObj.elementsToShow = 11;
			this.actionByAmount(newObj);
			return;
		}

		if (options.amount > 15 && changeWidth) {
			const newObj = Object.create(options);
			newObj.elementsToShow = 14;
			this.actionByAmount(newObj);
			return;
		}

		if (changeWidth) {
			const newObj = Object.create(options);
			newObj.elementsToShow = 15;
			this.actionByAmount(newObj);
		}
	},
	actionByAmount: function (options) {
		const objs = this.createCounterElement(options);
		while (options.parent.firstChild) {
			options.parent.removeChild(options.parent.firstChild);
		}
		const arrs = {
			show: options.arr.slice(0, options.elementsToShow),
			hide: options.arr.slice(options.elementsToShow)
		};
		arrs.hide.forEach(element => objs.hiddenElementsWrapper.appendChild(element));
		arrs.show.forEach(element => options.parent.appendChild(element));

		objs.hiddenElementsWrapper.style.display = 'none';
		this.showCircleWithAmount(objs, options, arrs.hide);

		// const parentPlaceholder = findClosestElementByClass(objs.circleWrapper, 'placeholder');
		// if (!parentPlaceholder) return;
		// if (parentPlaceholder.classList.contains('placeholder--b2c-gray')) {
		//     objs.circleWrapper.style.backgroundColor = '#fff';
		//     objs.circleWrapperArrow.style.backgroundColor = '#fff';
		// } else {
		//     objs.circleWrapper.style.backgroundColor = '#f7f7f7';
		//     objs.circleWrapperArrow.style.backgroundColor = '#f7f7f7';
		// }

		this.dropdownAnimation(objs, options.arr, options.parent, arrs);
	},
	showCircleWithAmount: function (objs, options, arr) {
		if (!arr.length) return;
		objs.circleContainer.appendChild(objs.circleWrapper);
		objs.circleContainerArrow.appendChild(objs.circleWrapperArrow);
		options.parent.appendChild(objs.circleContainer);
		objs.hiddenElementsWrapper.appendChild(objs.circleContainerArrow);
		options.parent.appendChild(objs.hiddenElementsWrapper);
		objs.hiddenElementsCounter.innerHTML = `+${arr.length}`;
	},
	createCounterElement: function (options) {
		const circleWrapper = this.createElement('button', ['elements-counter']);
		circleWrapper.setAttribute("type", "button");
		const circleTextShow = this.createElement('span', ['sr-only']);
		circleTextShow.innerHTML = options.parent.getAttribute('data-sr-text-show');
		const circleTextChannels = this.createElement('span', ['sr-only']);
		circleTextChannels.innerHTML = options.parent.getAttribute('data-sr-text-channels');

		const circleContainer = this.createElement('div', ['elements-counter__container']);
		const circleWrapperArrow = this.createElement('button', ['arrow']);
		circleWrapperArrow.setAttribute("type", "button");
		const circleTextHide = this.createElement('span', ['sr-only']);
		circleTextHide.innerHTML = options.parent.getAttribute('data-sr-text-hide');
		circleWrapperArrow.appendChild(circleTextHide);
		const circleContainerArrow = this.createElement('div', ['arrow__container']);
		const hiddenElementsCounter = this.createElement('span', ['elements-counter__number']);
		const hiddenElementsWrapper = this.createElement('div', ['hiddenPackages']);
		hiddenElementsWrapper.setAttribute("aria-expanded", "false");
		circleWrapper.appendChild(circleTextShow);
		circleWrapper.appendChild(hiddenElementsCounter);
		circleWrapper.appendChild(circleTextChannels);

		return {
			hiddenElementsCounter: hiddenElementsCounter,
			circleWrapper: circleWrapper,
			circleContainer: circleContainer,
			hiddenElementsWrapper: hiddenElementsWrapper,
			circleWrapperArrow: circleWrapperArrow,
			circleContainerArrow: circleContainerArrow
		}
	},
	createElement: function (type, classes) {
		const item = document.createElement(type);
		classes.forEach(className => item.classList.add(className));
		return item;
	},
	dropdownAnimation: function (elements, options, parentElement, arrs) {
		const commonParent = findClosestElementByClass(elements.circleWrapper, 'tv-packages');
		if (!commonParent) return;

		const imageHiddenText = commonParent.querySelector('.tv-packages__image-text--dropdown-hidden');
		const imageText = commonParent.querySelector('.tv-packages__image-text');
		const imageContainer = commonParent.querySelector('.tv-packages__image-container');

		if (imageText) imageText.style.display = null;
		if (imageHiddenText) imageHiddenText.style.display = null;

		elements.circleWrapper.addEventListener('click', () => {
			const elementToMove = this.chooseElementToMove(false, arrs.hide);
			this.moveElement(elementToMove, elements.hiddenElementsWrapper, parentElement);
			this.setVisibilityOfElement(elements.circleWrapper, elements.circleContainer);
			this.hideLabel(imageHiddenText, imageText, imageContainer);
			$(elements.hiddenElementsWrapper).slideDown("fast");
			elements.hiddenElementsWrapper.setAttribute("aria-expanded", "true");
			var x = window.scrollX,
				y = window.scrollY;
			if (typeof x === 'undefined') {
				x = document.documentElement.scrollLeft;
				y = document.documentElement.scrollTop;
			}
			elements.circleWrapperArrow.focus();
			window.scrollTo(x, y);

			var observer = lozad('.lozad', {});
			observer.observe();
			const lozadImages = elements.hiddenElementsWrapper.querySelectorAll('img');
			lozadImages.forEach(img => {
				observer.triggerLoad(img);
			});
		});

		elements.circleWrapperArrow.addEventListener('click', () => {
			const showElements = Array.from(parentElement.children);
			const elementToMove = this.chooseElementToMove(true, showElements);
			this.moveElement(elementToMove, elements.hiddenElementsWrapper.firstChild, elements.hiddenElementsWrapper);
			this.setVisibilityOfElement(elements.circleWrapper, elements.circleContainer);
			this.showLabel(imageHiddenText, imageText, imageContainer);
			$(elements.hiddenElementsWrapper).slideUp("fast");
			elements.hiddenElementsWrapper.setAttribute("aria-expanded", "false");
			var x = window.scrollX,
				y = window.scrollY;
			if (typeof x === 'undefined') {
				x = document.documentElement.scrollLeft;
				y = document.documentElement.scrollTop;
			}
			elements.circleWrapper.focus();
			window.scrollTo(x, y);
		});
	},
	showLabel: function (imageHiddenText, imageText, imageContainer) {
		if (window.innerWidth >= 1200) {
			imageText ? imageText.style.display = 'block' : null;
			imageContainer ? imageContainer.classList.remove('active') : null;
			imageHiddenText ? imageHiddenText.style.display = 'none' : null;
		}
	},
	hideLabel: function (imageHiddenText, imageText, imageContainer) {
		if (window.innerWidth >= 1200) {
			imageText ? imageText.style.display = 'none' : null;
			imageContainer ? imageContainer.classList.add('active') : null;
			imageHiddenText ? imageHiddenText.style.display = 'block' : null;
		}
	},
	setVisibilityOfElement: function (item, itemWrapper) {
		if (item.style.display == 'none') {
			item.style.display = 'flex';
			itemWrapper.style.display = 'flex';
		} else {
			item.style.display = 'none';
			itemWrapper.style.display = 'none';
		}
	},
	chooseElementToMove: function (lastPos, fromArray) {
		return lastPos ? fromArray[fromArray.length - 2] : fromArray[0];
	},
	moveElement: function (elementToMove, target, to) {
		to.insertBefore(elementToMove, target);
	}
}
